import { Component, HostBinding, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ContentService, HasSubscriptionsToClose } from '@agingplan';

@Component({
  selector: 'array-page-navigation',
  templateUrl: './array-page-navigation.component.html',
  styleUrls: ['./array-page-navigation.component.scss'],
})
export class ArrayPageNavigationComponent extends HasSubscriptionsToClose() {
  /**
   * The label to display next to the arrow
   */
  @HostBinding('attr.previous-label') @Input('previous-label') previous_label?: string;

  /**
   * The label to display next to the arrow
   */
  @HostBinding('attr.next-label') @Input('next-label') next_label = 'Next';

  constructor(private contentService: ContentService, private router: Router, private activatedRoute: ActivatedRoute) {
    super();
  }

  /**
   * Navigate to the current direction
   */
  public navigateTo(direction?: string) {
    if (direction === 'next') this.next();
    else {
      const path = this.router.url.split('/')[1];
      if (path == 'about') {
        this.router.navigate(['about']);
      } else {
        this.previous();
      }
    };
  }

  /**
   * If the current page is not the first page, navigate to the previous page. Otherwise, navigate to the last page
   */
  public previous(): void {
    const index = parseInt(this.activatedRoute.snapshot.paramMap.get('index') || '1') - 1;
    this.navigateToIndex(index);
  }

  /**
   * If the current page is not the last page, navigate to the next page. Otherwise, navigate to the first page
   */
  public next() {
    const index = parseInt(this.activatedRoute.snapshot.paramMap.get('index') || '-1') + 1;
    this.navigateToIndex(index);
  }

  /* Navigate to index page */
  public navigateToIndex(index: number){
    const path = this.router.url.split('/')[1];

    if (path && index >= 0) {
      this.contentService.navigateToPageIndex(path, index);
    }
  }
}
